<template>
  <div class="vx-row">
    <vx-card>

      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="12">

          <h6 class="ml-2">Client </h6> 
         
        </vs-col>
        <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="12">
        

          <h6 class="ml-2">User </h6> 
        

        </vs-col>
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">

        
         
        </vs-col>
      </vs-row>

      <vs-row vs-w="12" class="m-4">
        <vs-col vs-type="flex" vs-lg="5" vs-sm="4" vs-xs="12">

          <ClientAutocomplete
          :key="companySearchComponentKey" 
            class="searchbox"
            :list="searchCompany"
            :searchOn="'company_or_registration_no'"
            @event-name="handleClientEvent"
          ></ClientAutocomplete>
                   
        </vs-col>
        <vs-col
          vs-type="flex"
          vs-lg="5"
          vs-sm="4"
          vs-xs="12"
        >
        

        
        <ClientUserAutocomplete
            :key="clientUserSearchComponentKey"
            class="searchbox"
            :list="searchClientAndClientUser"
            :searchOn="'client_and_client_user'"
            @event-name="handleClientUserEvent"
          ></ClientUserAutocomplete>
                  

        </vs-col>
        <vs-col vs-type="flex" vs-lg="2" vs-sm="4" vs-xs="12">

          <vs-button
            icon="search"
            @click="searchClientAndUserView"
            >Search</vs-button
          >

          <vs-button
          class="ml-5"
            icon="cancel"
            @click="reset"
            >Reset</vs-button
          >
         
        </vs-col>
      </vs-row>

      <span class="ml-5" style="color:red">{{ client_required }}</span>
    </vx-card>
    
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import moduleClientsManagement from "@/store/clients-management/moduleClientsManagement.js";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import moduleClientUserManagement from "@/store/client-user-management/moduleClientUserManagement.js";
import ClientUserAutocomplete from "@/components/autocomplete/ClientUserAutocomplete.vue";
import vSelect from "vue-select";
export default {
  data: () => ({
    client_required: null,
    encoded_viewing_as_full_name:null,
    client_user_id:null,
    selected_client_id: null,
    viewing_as_full_name : null,
    clientUsers : null,
    sortedData: [],
      sortedbyASC: true,
    totalItems:10,
    abilities : null,
    clientUserSearchComponentKey : 0,
    companySearchComponentKey:0,
    selected: [],
    log: [],
    clients: null,
    selected_id: null,
  }),
  components: {
    ClientAutocomplete,
    ClientUserAutocomplete,
    "v-select": vSelect
  },
  computed: {
  },
  watch: {
  },
  methods: {

    handleClientUserEvent() {
      this.clientUsers = moduleClientUserManagement.state.client_users.datas;
      if (this.clientUsers){
        this.viewing_as_full_name = this.clientUsers[0]['first_name'] + " " + this.clientUsers[0]['surname']
        this.encoded_viewing_as_full_name = btoa(this.viewing_as_full_name)
        this.client_user_id = this.clientUsers[0].id
      }
    },
    reset(){
              this.companySearchComponentKey += 1;
              this.clientUserSearchComponentKey +=1;
              this.clients = null
              this.clientUsers = null
              this.client_required = null
              this.selected_client_id = null

    },
    searchClientAndClientUser(inputValue) {
      let self = this
      return this.$store
        .dispatch("clientUsersManagement/searchClientAndClientUser", inputValue)
        .then(response => {
          if (response) {
            let data = moduleClientUserManagement.state.client_user;
            if (data) {
              data =  data.filter(function(ele){
                if('client_id' in ele){
                  if (ele.client_id == self.selected_client_id ){
                     return ele

                  }
                }
              })
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].first_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].first_name +
                      " " +
                      data[property].surname +
                      " ",
                    type: "client_user"
                  });
                } 
                // else {
                //   mappedArray.push({
                //     id: data[property].id,
                //     name: data[property].company_name + " (Client)",
                //     type: "client"
                //   });
                // }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    searchCompany(inputValue) {
      return this.$store
        .dispatch("clientsManagement/getCompanyOrRegistrationNo", inputValue)
        .then(response => {
          if (response) {
            let data =
              moduleClientsManagement.state.company_or_registration_no;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                mappedArray.push({
                  id: data[property].id,
                  name:
                    data[property].company_name +
                    " - " +
                    data[property].company_registration_number
                });
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    goBack: function() {
      this.$router.go(0);
    },
    searchClientAndUserView: function() {
      
      if(this.selected_client_id){

        this.$router.push({
    path: "/views/client_view/search/" + this.selected_client_id + "/" + this.client_user_id +  "/" + this.encoded_viewing_as_full_name
  });

      }else{
        this.client_required = "Please select a client to continue"
      }

    },
    handleClientEvent(){
      this.clients = moduleClientsManagement.state.clients.datas
      if (this.clients){
        this.selected_client_id = this.clients[0]['id']
        this.client_required = null
      }
      // console.log("Client" , this.clients)
    },
  },
  created() {
        var self = this
    defineAbilitiesFor().then(function(data){
      self.abilities = data
    });
    if (!moduleClientsManagement.isRegistered) {
      this.$store.registerModule(
        "clientsManagement",
        moduleClientsManagement
      );
      moduleClientsManagement.isRegistered = true;
    }


    if (!moduleClientUserManagement.isRegistered) {
      this.$store.registerModule(
        "clientUsersManagement",
        moduleClientUserManagement
      );
      moduleClientUserManagement.isRegistered = true;
    }
  }
};
</script>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .tr-values .vs-table--td {
  padding: 15px 15px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  padding: 25px 15px;
  font-weight: 600;
  font-size: 14px;
}

.vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead th {
  width: 325px !important;
}

.searchbox {
  margin-left: 5px;
  width: 600px;
}

.pointer{
  cursor: pointer;
}

.item.expanded{
    background-color: white !important;
    color: black !important;
}

.tr-table-state-primary, .vs-table-primary .is-selected {
    background: none !important;
    box-shadow: none !important;
}


.tr-table-state-primary, .vs-table-primary .is-selected {
    color: #626262 !important;
    -webkit-box-shadow: 0 0 1px 0 rgba(var(--vs-primary),1)!important;
    box-shadow: 0 0 1px 0 rgba(var(--vs-primary),1)!important;
}

.address_th{
  padding: 30px;
}

.address_td{
  padding: 30px;
      font-weight: 500;
}
</style>

<style lang="stylus">
.con-expand-users
  .con-btns-user
    display flex
    padding 10px
    padding-bottom 0px
    align-items center
    justify-content space-between
    .con-userx
      display flex
      align-items center
      justify-content flex-start
  .list-icon
    i
      font-size .9rem !important
</style>
